module.exports = __webpack_public_path__ + "static/media/pbu_160_white.e23d4d47.png";